module.exports = __webpack_public_path__ + "img/banner3.90276cf0.jpg";